import React from 'react';
import styled from 'styled-components';
import type { EventEntity } from '../../types/api';
import EntityAvatar from '../EntityAvatar';
import { spacing, typography, colors } from '../../styles/theme';

const Row = styled.div`
  min-height: 30px;
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  margin-bottom: ${spacing[2]};
`;

const AvatarStack = styled.div`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: -6px;
  }
`;

const Summary = styled.span`
  min-width: 0;
  color: ${colors.text.secondary};
  font-size: ${typography.fontSizes.xs};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EventEntityAvatars: React.FC<{
  entities?: EventEntity[];
  maximum?: number;
}> = ({ entities = [], maximum = 3 }) => {
  const visible = entities.slice(0, maximum);
  if (visible.length === 0) return null;
  return (
    <Row aria-label="Related entities">
      <AvatarStack aria-hidden="true">
        {visible.map(entity => (
          <EntityAvatar
            key={entity.id}
            name={entity.displayName || entity.name}
            entityType={entity.type}
            logoUrl={entity.logoUrl}
            size={28}
          />
        ))}
      </AvatarStack>
      <Summary>
        {visible.map(entity => entity.displayName || entity.name).join(', ')}
        {entities.length > maximum ? ` +${entities.length - maximum}` : ''}
      </Summary>
    </Row>
  );
};

export default EventEntityAvatars;